import "../../App.css";

const CustomIcon = ({
    src = "/",
    alt = "logo",
    style = {},
    className = "",
    id = "",
    onClick = () => { },
}) => {
    return (
        <div id={id} onClick={onClick} className="inherit-bgcolor flex justify-center items-center" style={{ width: "40px", height: "40px", borderRadius: "50%", border: id !== "" ? "" : "1px solid #d1d5dc", ...style }}>
            <img
                className={className}
                src={src}
                alt={alt}
            />
        </div>
    );
};

export default CustomIcon;